import React from 'react';
import { motion } from 'framer-motion';
import { TrendingDownIcon } from 'lucide-react';
export function HookSection() {
  return <section className="py-20 px-4 relative" data-id="element-118">
      <div className="max-w-4xl mx-auto" data-id="element-119">
        <motion.div initial={{
        opacity: 0,
        y: 50
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.7
      }} className="glass-panel neon-box-purple rounded-2xl p-8 md:p-12 relative overflow-hidden" data-id="element-120">
          {/* Decorative background element */}
          <div className="absolute -right-20 -top-20 opacity-10" data-id="element-121">
            <TrendingDownIcon size={300} className="text-[#8B5CF6]" data-id="element-122" />
          </div>

          <div className="flex flex-col md:flex-row gap-8 items-center relative z-10" data-id="element-123">
            <div className="flex-shrink-0 text-center md:text-left" data-id="element-124">
              <span className="text-7xl md:text-9xl font-black neon-text-green block leading-none" data-id="element-125">
                85%
              </span>
            </div>

            <div className="text-lg md:text-xl text-gray-300 space-y-4" data-id="element-126">
              <p data-id="element-127">
                <strong className="text-white" data-id="element-128">
                  ¿Sabías que el 85% de los adolescentes llegan a los 20 años
                  sin saber absolutamente nada sobre cómo funciona el dinero?
                </strong>
              </p>
              <p data-id="element-129">
                Pasan 12 años en el colegio aprendiendo fórmulas matemáticas que
                nunca usarán, pero nadie les enseña qué hacer cuando reciben sus
                primeros $20 de mesada o su primer pago por un trabajo.
              </p>
              <p data-id="element-130">
                El resultado: el dinero entra y desaparece en menos de 48 horas
                en comida rápida, suscripciones olvidadas y skins de
                videojuegos.{' '}
                <span className="text-[#39FF14] font-semibold" data-id="element-131">
                  Estás a un paso de romper ese ciclo para siempre.
                </span>
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}